import { useEffect, useRef, useState } from 'react';
import TestimonialCard from "../../../../Components/TestimonialCard/TestimonialCard";
import './Testimonials.scss';
import {useTranslation} from "react-i18next";

const testimonialsData = {
    items: [
        {
            id: 1,
            name: 'NonsonoGiaco',
            server: 'SCARLETMC',
            image:
                'https://ik.imagekit.io/n4dmneisyc/enderclub/testimonials/giaco.jpg',
        },
        {
            id: 2,
            name: 'bystrictv',
            server: 'SPACEVALLEY',
            image:
                'https://ik.imagekit.io/n4dmneisyc/enderclub/testimonials/bystric.jpg',
        },
        {
            id: 3,
            name: 'blerfig',
            server: 'Minecraft Builder',
            image:
                'https://cdn.discordapp.com/avatars/1102616235398660146/8dc7de81d923bc7d48a163620c607ab6.png',
        },
        {
            id: 4,
            name: 'venrixmc',
            server: 'VenrixMC',
            image:
                'https://cdn.discordapp.com/avatars/1443980883710181408/d556050c13a93905bd0c390d2db38c04.png',
        },
        {
            id: 5,
            name: 'd4vide106',
            server: 'Dev & Founder',
            image:
                'https://cdn.discordapp.com/avatars/768071128999788555/f622e4ed7e91f9ea6dd476c42ff225fb.png',
        },
    ],
};

export default function Testimonials() {
    const { t } = useTranslation();
    const {
        items,
    } = testimonialsData;

    const sectionRef = useRef<HTMLDivElement>(null);
    const trackRef = useRef<HTMLDivElement>(null);
    const groupRef = useRef<HTMLDivElement>(null);

    const [inView, setInView] = useState(false);

    /**
     * Attiva/disattiva l'animazione quando la sezione
     * entra o esce dal viewport.
     */
    useEffect(() => {
        const section = sectionRef.current;

        if (!section) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setInView(entry.isIntersecting);
            },
            {
                threshold: 0.1,
            }
        );

        observer.observe(section);

        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        if (!inView) return;

        const track = trackRef.current;
        const group = groupRef.current;

        if (!track || !group) return;

        let animationId: number;
        let position = group.offsetWidth;

        const speed = 0.8;

        const animate = () => {
            const groupWidth = group.offsetWidth;

            if (groupWidth <= 0) {
                animationId = requestAnimationFrame(animate);
                return;
            }

            position -= speed;

            if (position <= 0) {
                position += groupWidth;
            }

            track.style.transform = `translate3d(${-position}px, 0, 0)`;

            animationId = requestAnimationFrame(animate);
        };

        track.style.transform = `translate3d(${-position}px, 0, 0)`;

        animationId = requestAnimationFrame(animate);

        return () => {
            cancelAnimationFrame(animationId);
            track.style.transform = 'translate3d(0, 0, 0)';
        };
    }, [inView]);


    return (
        <section
            ref={sectionRef}
            className="testimonials-section"
        >
            <header className="growth-services__header">
                <h2>{t("home.testimonials.title")}</h2>

                <p>{t("home.testimonials.subtitle")}</p>
            </header>

            <div className="testimonials-container">
                <div className="testimonials-carousel-wrapper">
                    <div className="testimonials-fade-left" />

                    <div className="testimonials-fade-right" />

                    <div
                        ref={trackRef}
                        className="testimonials-track"
                    >
                        {/* PRIMO GRUPPO */}
                        <div
                            ref={groupRef}
                            className="testimonials-group"
                        >
                            {items.map((item, index) => (
                                <TestimonialCard
                                    key={`first-${item.id}`}
                                    item={item}
                                    index={index}
                                />
                            ))}
                        </div>

                        {/* SECONDO GRUPPO IDENTICO */}
                        <div
                            className="testimonials-group"
                            aria-hidden="true"
                        >
                            {items.map((item, index) => (
                                <TestimonialCard
                                    key={`second-${item.id}`}
                                    item={item}
                                    index={index}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
